module.exports = __webpack_public_path__ + "img/studentCard.e396ce1c.png";